export const formatBatchDate = (folderPath) => {
  const dateString = folderPath.replace('output/', '').replace('/', '').replace('-retranslation', '');
  const [date, time] = dateString.split('T');
  if (!time) return folderPath;

  const timestamp = Date.parse(`${date}T${time.replace(/-/g, ':')}`);
  return Number.isNaN(timestamp) ? folderPath : new Date(timestamp).toLocaleString('en-US');
};
